import { BaseFiltroPagDTO } from "./base-dto";

export class PrescricaoEnderecoRelatorioFiltroDTO extends BaseFiltroPagDTO {
  dataIni: string;
  dataFim: string;
}